"use strict";
/* eslint-disable max-lines */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltWorkLocation = exports.triggerformOutputVariables = void 0;
const variables_1 = require("@whispir/variables");
const templateUtils_1 = require("../../templateUtils");
/**
 * Good to be using workflow factories to create this workflow templates
 */
exports.triggerformOutputVariables = [
    {
        type: 'Recipient',
        variableId: '8358-internal-recipient-id',
        variableName: 'Recipient',
        variableType: 'recipient',
    },
    {
        type: 'Text',
        variableId: '8358-internal-recipient-firstname',
        variableName: 'Recipient: First Name',
        variableType: 'string',
    },
    {
        type: 'Text',
        variableId: '8358-internal-recipient-lastname',
        variableName: 'Recipient: Last Name',
        variableType: 'string',
    },
    {
        type: 'PhoneNumber',
        variableId: '8358-internal-recipient-mobilephone1',
        variableName: 'Recipient: Phone No.',
        variableType: 'string',
    },
    {
        type: 'EmailAddress',
        variableId: '8358-internal-recipient-emailaddress1',
        variableName: 'Recipient: Email',
        variableType: 'string',
    },
    {
        type: 'Date',
        variableId: '8358-internal-message-timestamp',
        variableName: 'Message: Time Sent',
        variableType: 'date',
    },
];
const triggerFormVariablesAsInputVariables = exports.triggerformOutputVariables.map(({ variableId, variableName, variableType }) => ({
    id: variableId,
    valueType: variableType,
    inputType: 'system',
    label: variableName,
}));
const officeConfirmationNoResponseEmail = {
    subject: '<span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span>  has not responded.',
    contentId: 'cbea7578-8238-4624-b449-cc532de0f4a8',
    contentType: 'html',
    contentData: [
        {
            type: 'display-text',
            version: '1',
            id: '1ede3cd6-4309-4ce4-b730-6ada4cac61f6',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi there,</p><p></p><p>No response has been received from <span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span>.</p><p></p><p>Please follow up with them directly on <span data-variableid="8358-internal-recipient-mobilephone1">Recipient: Phone No.</span>.</p>',
            },
        },
    ],
    inputVariables: [
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
        ...triggerFormVariablesAsInputVariables,
    ],
    outputVariables: [],
    workspaceId: 'FAA4358B519D0E89',
};
const officeConfirmationWeb = {
    subject: 'Work Location Weekly Check in',
    contentType: 'html',
    contentData: [
        {
            type: 'display-text',
            version: '1',
            id: '18289c5b-1b76-4a3b-9dd6-1f37b3207753',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span>,</p><p></p><p>Thanks for letting us know you&#x27;ll be coming into the office next week. Upon arrival you will be asked to sign in before you are granted entry to the office.</p><p></p><p>As a reminder, we are taking extra precautions to avoid the risk of any potential COVID-19 outbreaks. </p><p></p><p>If you are experiencing any of the below symptoms or have been in contact with anyone who has, please <strong>get tested immediately and do not come into the office.</strong></p><ul><li>fever</li><li>coughing</li><li>sore throat</li><li>shortness of breath</li></ul><p>If you are not experiencing any of the above symptoms and have not come into contact with anyone who has, please find below our <strong>COVID-19 guidelines to work from the office safely.</strong></p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'f8471dd1-08fc-49e2-919f-417ad472d6e2',
            data: {
                text: '<h2>Wear a face mask at all times</h2>',
                position: 'middle-middle',
                color: '#000000',
                textPadding: 0,
                src: '',
                backgroundColor: '#FFFFFF',
                height: 50,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'display-image',
            version: '1',
            id: 'e5e8fe40-babb-4ffd-b2be-ec50464e3996',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/cover.png',
                width: 12,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'ba651be5-1a5a-43e4-a398-980df022d953',
            data: {
                text: '<h2>Stay least 1.5m apart at all times</h2>',
                position: 'middle-middle',
                color: '#000000',
                textPadding: 0,
                src: '',
                backgroundColor: '#FFFFFF',
                height: 50,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'display-image',
            version: '1',
            id: 'cb429c04-1d6f-45e2-a516-cdf7420f026d',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/crowd_density_human.png',
                width: 12,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '89e18f60-dcd2-4cee-b545-75bb0c088ab4',
            data: {
                text: '<h2>Wash your hands regularly with hand sanitiser</h2>',
                position: 'middle-middle',
                color: '#000000',
                textPadding: 0,
                src: '',
                backgroundColor: '#FFFFFF',
                height: 50,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'display-image',
            version: '1',
            id: '60836fcb-0cf0-4289-a3a0-a2c5573d8279',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/apply_antibacterial_gel.png',
                width: 12,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '43f00685-72c1-4410-948b-a04ebe40800d',
            data: {
                text: '<h2>Have no more than 3 people in a meeting room</h2>',
                position: 'middle-middle',
                color: '#000000',
                textPadding: 0,
                src: '',
                backgroundColor: '#FFFFFF',
                height: 50,
                fullWidth: false,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'display-image',
            version: '1',
            id: '9dedbe22-7a98-4642-a271-466eed305a76',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/stay_home.png',
                width: 12,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '21800335-222e-45a1-8bc1-344cb2e5d706',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>We look forward to seeing you next week, in the meantime if you have any questions at all, please do not hesitate to contact HR.</p>',
            },
        },
        {
            type: 'display-footer',
            version: '1',
            id: '23baed8a-103e-457a-a243-e72319ef61b3',
            data: {
                color: '#70707B',
                backgroundColor: '#F6F6F7',
                logoWidth: 100,
                logoSrc: 'https://cdn-au.whispir.com/public/resources/31f6ed3d480a67001efb340291a858c2d4.png',
                logoAltText: '',
                text: '<p>Cras montes amet fusce. Turpis quis porta platea! Conubia primis metus, magnis viverra ante quisque. Platea primis litora lorem. Mus quis volutpat sollicitudin aenean euismod sagittis ac.</p>',
                links: [
                    {
                        id: '2d6b363b-6c2c-40b8-b72e-2d4fb1497f4d',
                        text: 'Company Name',
                        link: '',
                        background: '',
                    },
                    {
                        id: '36a9ad67-2bb5-42d4-a46d-f0d500958458',
                        text: 'Privacy',
                        link: '',
                        background: '',
                    },
                    {
                        id: '5c147641-6c0b-4b8e-97b3-fd133a8f33e1',
                        text: 'Unsubscribe',
                        link: 'Enter a link',
                        background: '#6200EE',
                    },
                ],
                textAlign: 'left',
                imageAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
    ],
    inputVariables: [
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
        ...triggerFormVariablesAsInputVariables,
    ],
    outputVariables: [],
};
const officeHrConfirmationAuditEmail = {
    subject: '<span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> is working from the office next week.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'a4055350-09a6-497b-8674-bbab4c368cf0',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/OfficeCheckIn.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'bed5515f-03d5-430e-9d68-ac65a6f33c5e',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi there,</p><p></p><p><span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> has indicated they <strong>will be working from the office next week.</strong></p><p></p><p>An automated confirmation message has been sent to <span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> on their mobile phone number of: <span data-variableid="8358-internal-recipient-mobilephone1">Recipient: Phone No.</span>. This message contains a link to the up to date office safety guidelines.</p><p></p><p>Please find below the details of the confirmation:</p><p></p><p><strong>Staff Name: </strong><span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> <span data-variableid="8358-internal-recipient-lastname">Recipient: Last Name</span></p><p><strong>Staff Phone Number: </strong><span data-variableid="8358-internal-recipient-mobilephone1">Recipient: Phone No.</span></p><p><strong>Initial Send Message Time: </strong><span data-variableid="8358-internal-message-timestamp">Message: Time Sent</span> </p><p><strong>Staff Response: </strong><span data-variableid="385-internal-response-body">Response: Message Body</span></p><p><strong>Staff Response Time: </strong><span data-variableid="8358-internal-response-timestamp">Response: Time Received</span></p><p> </p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'bd861ce6-c204-4a9d-bf22-deb0c0cefdbf',
            data: {
                text: '<p><strong>Please Note:</strong> This is an automated message for future audit purposes.</p>',
                position: 'middle-middle',
                color: '#9E9E9E',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
        ...triggerFormVariablesAsInputVariables,
    ],
    outputVariables: [],
};
const homeConfirmationAuditEmail = {
    subject: '<span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> is working from home next week.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'eaefa662-3874-4c71-a0e3-70c2e9dfcefa',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/WFH.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '8bf0deb3-cb30-4049-b07a-861dd4c167e2',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi there,</p><p></p><p><span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> has indicated they <strong>will be working from home next week.</strong></p><p></p><p>An automated confirmation message has been sent to <span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> on their mobile phone number of: <span data-variableid="8358-internal-recipient-mobilephone1">Recipient: Phone No.</span>.</p><p></p><p>Please find below the details of the confirmation:</p><p></p><p><strong>Staff Name:</strong> <span data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> <span data-variableid="8358-internal-recipient-lastname">Recipient: Last Name</span></p><p><strong>Staff Phone Number:</strong> <span data-variableid="8358-internal-recipient-mobilephone1">Recipient: Phone No.</span></p><p><strong>Initial Send Message Time:</strong> <span data-variableid="8358-internal-message-timestamp">Message: Time Sent</span></p><p><strong>Staff Response:</strong> <span data-variableid="385-internal-response-body">Response: Message Body</span></p><p><strong>Staff Response Time:</strong> <span data-variableid="8358-internal-response-timestamp">Response: Time Received</span></p><p> </p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'bf3c4fb2-fa16-4f0f-8cc8-e39f0f328171',
            data: {
                text: '<p><strong>Please Note:</strong> This is an automated message for future audit purposes.</p>',
                position: 'middle-middle',
                color: '#9E9E9E',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
        ...triggerFormVariablesAsInputVariables,
    ],
    outputVariables: [],
};
const prebuiltWorkLocation = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [],
            },
            type: 'start',
            next: [
                {
                    id: 8358,
                    variables: {
                        input: [],
                        output: exports.triggerformOutputVariables,
                    },
                    type: 'task',
                    action: 'send-sms',
                    next: [
                        {
                            id: 385,
                            type: 'condition',
                            action: 'on-sms-reply',
                            variables: {
                                input: [],
                                output: [
                                    {
                                        type: 'Text',
                                        variableId: '385-internal-response-body',
                                        variableName: 'Response: Message Body',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'Date',
                                        variableId: '8358-internal-response-timestamp',
                                        variableName: 'Response: Time Received',
                                        variableType: 'date',
                                    },
                                ],
                            },
                            next: [
                                {
                                    id: 5067,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 1929,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-sms',
                                            next: [
                                                {
                                                    id: 4757,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    type: 'task',
                                                    action: 'send-email',
                                                    next: null,
                                                    isDirty: true,
                                                    version: '1.0.4',
                                                    data: {
                                                        stepName: 'Office HR Confirmation Audit',
                                                        workspaceId,
                                                        message: {
                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                    return request(Object.assign(Object.assign({}, officeHrConfirmationAuditEmail), { workspaceId }));
                                                                }),
                                                            }),
                                                            type: 'email',
                                                        },
                                                        link: null,
                                                        recipients: [],
                                                        collectResponses: false,
                                                    },
                                                },
                                            ],
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                stepName: 'Office Confirmation SMS',
                                                workspaceId,
                                                message: {
                                                    content: {
                                                        type: 'raw',
                                                        subject: '<p>Office Confirmation SMS</p>',
                                                        body: '<p>Hi <span data-stepid="8358" data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span> ,</p><p></p><p>Thanks for letting us know you intend to work from the office next week. Please click the link below to read important COVID-19 safety guidelines about working from the office.</p><p></p><p><span data-systemvariable="web_link">web_link</span> </p>',
                                                    },
                                                    type: 'sms',
                                                },
                                                link: {
                                                    type: 'web',
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                            return request(Object.assign(Object.assign({}, officeConfirmationWeb), { workspaceId }));
                                                        }),
                                                    }),
                                                },
                                                recipients: [
                                                    {
                                                        type: 'variable',
                                                        stepId: '8358',
                                                        variableId: '8358-internal-recipient-id',
                                                    },
                                                ],
                                                collectResponses: false,
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: 'f5c8ae01-ba87-44fa-ba4e-f2754bc084ea',
                                            type: 'expression',
                                            operator: 'contains',
                                            right: {
                                                type: 'constant',
                                                value: 'office, wfo',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: '385-internal-response-body',
                                                stepId: '385',
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 6058,
                                    type: 'condition',
                                    next: [
                                        {
                                            id: 1002,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-sms',
                                            next: [
                                                {
                                                    id: 9583,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    type: 'task',
                                                    action: 'send-email',
                                                    next: null,
                                                    isDirty: true,
                                                    version: '1.0.4',
                                                    data: {
                                                        stepName: 'Home Confirmation Audit',
                                                        workspaceId,
                                                        message: {
                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                    return request(Object.assign(Object.assign({}, homeConfirmationAuditEmail), { workspaceId }));
                                                                }),
                                                            }),
                                                            type: 'email',
                                                        },
                                                        link: null,
                                                        recipients: [],
                                                        collectResponses: false,
                                                    },
                                                },
                                            ],
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                stepName: 'Home Confirmation SMS',
                                                workspaceId,
                                                message: {
                                                    content: {
                                                        type: 'raw',
                                                        subject: '<p>Home Confirmation SMS</p>',
                                                        body: '<p>Hi <span data-stepid="8358" data-variableid="8358-internal-recipient-firstname">Recipient: First Name</span>,</p><p></p><p>Thanks for letting us know you&#x27;ll be working from home next week.</p><p></p><p>We&#x27;ll check in again with you next week to see if your situation has changed.</p><p></p><p>Stay safe!</p><p></p><p>HR</p>',
                                                    },
                                                    type: 'sms',
                                                },
                                                link: null,
                                                recipients: [
                                                    {
                                                        type: 'variable',
                                                        stepId: '8358',
                                                        variableId: '8358-internal-recipient-id',
                                                    },
                                                ],
                                                collectResponses: false,
                                            },
                                        },
                                    ],
                                    action: 'expression',
                                    isDirty: true,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    version: '1.0.1',
                                    data: {
                                        stepName: 'IF Condition',
                                        expression: {
                                            id: '95a71c40-e42d-487d-8003-9b030dbe966c',
                                            type: 'expression',
                                            operator: 'contains',
                                            right: {
                                                type: 'constant',
                                                value: 'home, wfh',
                                                valueType: 'string',
                                            },
                                            left: {
                                                type: 'variable',
                                                variableId: '385-internal-response-body',
                                                stepId: '385',
                                            },
                                        },
                                    },
                                },
                            ],
                            isDirty: true,
                            version: '1.0.1',
                            data: {
                                stepName: 'Replies for: WFO/WFH Confirmation',
                                messageId: {
                                    variableId: '8358-internal-message-id',
                                    stepId: 8358,
                                    valueType: 'number',
                                },
                                collectResponses: {
                                    duration: {
                                        days: 0,
                                        hours: 2,
                                        minutes: 0,
                                    },
                                },
                            },
                        },
                        {
                            id: 4347,
                            type: 'condition',
                            action: 'on-sms-no-reply',
                            variables: {
                                input: [],
                                output: [],
                            },
                            next: [
                                {
                                    id: 5909,
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    type: 'task',
                                    action: 'send-email',
                                    next: null,
                                    isDirty: true,
                                    version: '1.0.4',
                                    data: {
                                        stepName: 'No Response',
                                        workspaceId,
                                        message: {
                                            content: yield (0, templateUtils_1.getContentData)({
                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                    return request(Object.assign(Object.assign({}, officeConfirmationNoResponseEmail), { workspaceId }));
                                                }),
                                            }),
                                            type: 'email',
                                        },
                                        link: null,
                                        recipients: [],
                                        collectResponses: false,
                                    },
                                },
                            ],
                            isDirty: true,
                            version: '1.0.1',
                            data: {
                                stepName: 'No Replies for: WFO/WFH Confirmation',
                                messageId: {
                                    variableId: '8358-internal-message-id',
                                    stepId: 8358,
                                    valueType: 'number',
                                },
                                collectResponses: {
                                    duration: {
                                        days: 0,
                                        hours: 2,
                                        minutes: 0,
                                    },
                                },
                            },
                        },
                    ],
                    isDirty: true,
                    version: '1.0.4',
                    data: {
                        stepName: 'WFO/WFH Confirmation',
                        workspaceId,
                        message: {
                            content: {
                                type: 'raw',
                                subject: '<p>WFO/WFH Confirmation</p>',
                                body: '<p>Hi <span data-systemvariable="first_name">first_name</span>,</p><p></p><p>Please let us know where you will be working from next week. Reply with &quot;office&quot; if you intend on coming into the office, or &quot;home&quot; if you will continue to work from home.</p><p></p><p>Thanks</p><p>The HR Team</p>',
                            },
                            type: 'sms',
                        },
                        link: null,
                        recipients: [],
                        collectResponses: true,
                    },
                },
            ],
            version: '1.0.1',
            data: {
                stepName: 'Manual Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'manual',
                    },
                ],
            },
        },
    ];
});
exports.prebuiltWorkLocation = prebuiltWorkLocation;
//# sourceMappingURL=workLocation.js.map